import React from "react";
import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMailCheckFill, RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import { useRef } from "react";
import emailjs from "emailjs-com";
import { useState } from "react";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";

function Contact({ darkMode }) {
  const form = useRef();
  const [mailSent, setMailSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    setMailSent(false);
    setLoading(true);
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6e5f6cl",
        "template_m5xw4sp",
        form.current,
        "JA57HkidDzSsYb0Pv"
      )
      .then(
        (result) => {
          setLoading(false);
          setMailSent(true);
          e.target.reset();
        },
        (error) => {
          setLoading(false);
          setMailSent(false);
          e.target.reset();
        }
      );
  };
  return (
    <section id="contact" className="contact">
      <h5>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          Get In Touch
        </AnimationOnScroll>
      </h5>
      <h2>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          Contact Me
        </AnimationOnScroll>
      </h2>
      <div
        className={
          darkMode
            ? "container contact__container"
            : "container contact__container light"
        }
      >
        <div className="contact__options">
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__bounceIn"
            delay={250}
          >
            <article className="contact__option">
              <MdOutlineEmail className="contact__option-icon" />
              <h4>Email</h4>
              <h5>aungkaungmyat@gmail.com</h5>
              <a href="https://gmail.com" target="_blank">
                Send a message
              </a>
            </article>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__bounceIn"
            delay={500}
          >
            <article className="contact__option">
              <RiMessengerLine className="contact__option-icon" />
              <h4>Messenger</h4>
              <h5>陽翔 (Haruto)</h5>
              <a href="http://m.me/TheLegendaryOtakuSenpai" target="_blank">
                Send a message
              </a>
            </article>
          </AnimationOnScroll>
          <AnimationOnScroll
            animateOnce="true"
            animateIn="animate__bounceIn"
            delay={500}
            offset="50"
          >
            <article className="contact__option">
              <BsWhatsapp className="contact__option-icon" />
              <h4>WhatsApp</h4>
              <h5>+959784755423</h5>
              <a
                href="https://api.whatsapp.com/send?phone+959784755423"
                target="_blank"
              >
                Send a message
              </a>
            </article>
          </AnimationOnScroll>
        </div>
        {/*Form Email*/}
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <textarea
              name="message"
              rows="7"
              required
              placeholder="Your Feed Back"
            ></textarea>
            <button
              type="submit"
              className="btn btn-primary "
              disabled={loading}
              style={{ fontSize: ".9rem" }}
            >
              <div className="contact__option-mail">
                {mailSent ? (
                  <>
                    <RiMailCheckFill className="contact__option-icon-mail" />
                    Mail Received!{" "}
                  </>
                ) : loading ? (
                  <>
                    <div className="lds-circle">
                      <div></div>
                    </div>
                    Sending{" "}
                  </>
                ) : (
                  <>Send Message </>
                )}
              </div>
            </button>
          </form>
        </AnimationOnScroll>
      </div>
    </section>
  );
}

export default Contact;
